var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.40001 0.5C4.25785 0.5 0.900009 3.85784 0.900009 8C0.900009 12.1422 4.25785 15.5 8.40001 15.5C12.5422 15.5 15.9 12.1422 15.9 8C15.9 3.85784 12.5422 0.5 8.40001 0.5ZM8.40001 14C5.0916 14 2.40001 11.3084 2.40001 8C2.40001 4.69159 5.0916 2 8.40001 2C11.7084 2 14.4 4.69159 14.4 8C14.4 11.3084 11.7084 14 8.40001 14ZM9.65001 10.5H9.15001V7.75C9.15001 7.33594 8.81407 7 8.40001 7H7.40001C6.98595 7 6.65001 7.33594 6.65001 7.75C6.65001 8.16406 6.98595 8.5 7.40001 8.5H7.65001V10.5H7.15001C6.73595 10.5 6.40001 10.8359 6.40001 11.25C6.40001 11.6641 6.73595 12 7.15001 12H9.65001C10.0641 12 10.4 11.6641 10.4 11.25C10.4 10.8359 10.0641 10.5 9.65001 10.5ZM8.40001 6C8.95232 6 9.40001 5.55225 9.40001 5C9.40001 4.44769 8.95232 4 8.40001 4C7.8477 4 7.40001 4.44769 7.40001 5C7.40001 5.55225 7.8477 6 8.40001 6Z",
    fill: "#212131"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/Help.a43fe2ffea75324cbacea8f9e01196b2.svg";
export { ForwardRef as ReactComponent };